import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=6a04f8dd&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a04f8dd')) {
      api.createRecord('6a04f8dd', component.options)
    } else {
      api.reload('6a04f8dd', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=6a04f8dd&", function () {
      api.rerender('6a04f8dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2r5bOZi66Cwiw/JS/comp/IncreaseNumber.vue"
export default component.exports